<mat-toolbar fxLayout="row" color="primary" id="mifosx-toolbar">
  <button
    mat-icon-button
    *ngIf="!sidenavCollapsed"
    (click)="toggleSidenav()"
    matTooltip="{{ 'TOOLBAR.TOGGLE_SIDENAV' | translate }}"
    matomoTrack
    category="Navigation"
    action="Toggle Sidenav"
    name="Hide/Open Menu"
  >
    <fa-icon icon="bars" size="lg"></fa-icon>
  </button>

  <button
    mat-icon-button
    *ngIf="sidenav.opened"
    (click)="toggleSidenavCollapse()"
    matTooltip="{{ 'TOOLBAR.TOGGLE_COLLAPSE' | translate }}"
    fxHide.lt-md="true"
    matomoTrack
    category="Navigation"
    action="Toggle Collapse"
    name="Collapse Menu"
  >
    <fa-icon *ngIf="!sidenavCollapsed" icon="chevron-left"></fa-icon>
    <fa-icon *ngIf="sidenavCollapsed" icon="chevron-right"></fa-icon>
  </button>

  <nav mat-tab-nav-bar backgroundColor="primary" class="ml-1">
    <span>
      <a
        *ngIf="canViewPaymentHubMenu()"
        mat-tab-link
        class="tab-link"
        [routerLink]="['/paymenthubee']"
        matomoTrack
        category="Navigation"
        action="Tab Click"
        name="Payment Hub EE"
      >
        <fa-icon class="mr-05" icon="money-bill-alt" size="lg"></fa-icon>
        {{ "TOOLBAR.PAYMENT_HUB_EE" | translate }}
      </a>

      <a
        *ngIf="canViewAdmin()"
        mat-tab-link
        class="tab-link"
        [matMenuTriggerFor]="adminMenu"
        #adminMenuTrigger="matMenuTrigger"
        matomoTrack
        category="Navigation"
        action="Tab Click"
        name="Admin"
      >
        <fa-icon class="mr-05" icon="shield-alt" size="lg"></fa-icon>
        {{ "TOOLBAR.ADMIN" | translate }}
      </a>
    </span>

    <span>
      <mat-form-field class="tenant-selector ml-1" appearance="outline" fxHide.lt-md="true">
        <mat-label>{{ "TOOLBAR.COUNTRY" | translate }}</mat-label>
        <mat-select [value]="selectedTenant" (selectionChange)="onTenantChange($event.value)">
          <mat-option *ngFor="let tenant of tenants" [value]="tenant">{{ tenant | uppercase }}</mat-option>
        </mat-select>
      </mat-form-field>
    </span>

  </nav>

  <span fxFlex="auto" class="username">{{ displayUser() }}</span>

  <!--
    TODO: Search
    Separate into its own component in shared module for reuse.
    Implement functionality.
  -->
  <div
    *ngIf="searchVisible"
    class="search-bar"
    fxFlex="auto"
    fxHide.lt-sm="true"
    [@fadeInOut]
  >
    <mat-form-field class="search">
      <mat-label>{{ "TOOLBAR.SEARCH" | translate }}</mat-label>
      <input matInput type="text" />
    </mat-form-field>
  </div>

  <button
    mat-icon-button
    class="ml-1"
    (click)="toggleSearchVisibility()"
    fxHide.lt-sm="true"
    matomoTrack
    category="Search"
    action="Toggle Search"
    name="Search Button"
  >
    <fa-icon icon="search" size="lg"></fa-icon>
  </button>

  <mifosx-language-selector
    class="ml-1 language"
    fxHide.lt-md
  ></mifosx-language-selector>

  <mifosx-theme-picker fxHide.lt-md></mifosx-theme-picker>

  <!--
    TODO: Notifications
    Separate into its own component in shared module for reuse.
    Implement functionality.
  -->
  <button
    mat-icon-button
    class="ml-1"
    matTooltip="{{ 'TOOLBAR.NOTIFICATIONS' | translate }}"
    matomoTrack
    category="Navigation"
    action="Click"
    name="Notifications"
  >
    <fa-icon icon="bell" size="lg"></fa-icon>
  </button>

  <button
    mat-icon-button
    class="ml-1 img-button"
    [matMenuTriggerFor]="applicationMenu"
    matomoTrack
    category="Navigation"
    action="User Menu Click"
    name="User Menu"
  >
    <img src="assets/images/user_placeholder.png" />
  </button>

</mat-toolbar>

<mat-menu #adminMenu="matMenu" [overlapTrigger]="false">
  <button 
    *ngIf="canViewUsers()"
    mat-menu-item [routerLink]="['/users']">
    {{ "TOOLBAR.USERS" | translate }}
  </button>
  <button 
    *ngIf="canViewSystem()"
    mat-menu-item [routerLink]="['/system']">
    {{ "TOOLBAR.SYSTEM" | translate }}
  </button>
</mat-menu>

<!-- Application User Help Menu -->
<mat-menu #applicationMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item [routerLink]="['/settings']">
    <mat-icon>
      <fa-icon icon="cog" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ "TOOLBAR.SETTINGS" | translate }}</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>
      <fa-icon icon="sign-out-alt" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ "TOOLBAR.SIGN_OUT" | translate }}</span>
  </button>
</mat-menu>
